'use strict';

const isTabletView = () => {
    const tabletminWidth = 768;
    const tabletMaxWidth = 1024;
    const vpWidth = $(window).width();

    return vpWidth >= tabletminWidth && vpWidth <= tabletMaxWidth;
};

module.exports = isTabletView;
